export default function NotificationsPage() {
  return (
    <div className="space-y-5 max-w-[1440px] mx-auto">
      <h1 className="text-xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
        通知中心
      </h1>
      <div className="bg-background-50 border border-background-200 rounded-xl p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
          <i className="ri-notification-3-line text-primary-500 text-2xl" />
        </div>
        <h2 className="text-lg font-semibold text-foreground-900 mb-2">通知中心</h2>
        <p className="text-sm text-foreground-500">此頁面將顯示所有系統通知、部門訊息與待處理提醒</p>
      </div>
    </div>
  );
}